<form [formGroup]="forgotPasswordForm" (ngSubmit)="submitForm()">
  <p-float-label class="w-full mb-8">
    <input [id]="id + 'email'" pInputText type="email" formControlName="email"
      [pTooltip]="formWatched['children']['email']() | formFieldFeedback" tooltipEvent="focus" tooltipPosition="bottom"
      required class="w-full" />
    <label [for]="id + 'email'">E-mail</label>
  </p-float-label>

  <p-button styleClass="w-full mb-4 font-semibold" [loading]="isLoading()" [disabled]="isLoading() || !enabled()"
    type="submit" label="Enviar" />
</form>